import qs from 'qs';
import axios from 'axios';
import store from '@/store';

function getPerformanceBuffer(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/buffer${query}`);
}

function getPlaybackResolutionPerformance(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/playback-resolution${query}`);
}

function getUserAgent(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/user-agent${query}`);
}

function getOSFamily(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/os-family${query}`);
}

function getISPPerformance(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/isp${query}`);
}

function getAdsPerformance(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/performance/ad-indicator${query}`);
}

export {
  getPerformanceBuffer,
  getPlaybackResolutionPerformance,
  getUserAgent,
  getOSFamily,
  getISPPerformance,
  getAdsPerformance,
};
